import { render, staticRenderFns } from "./DataListLiftingEquipments_validate.vue?vue&type=template&id=87615ba2&scoped=true&"
import script from "./DataListLiftingEquipments_validate.vue?vue&type=script&lang=js&"
export * from "./DataListLiftingEquipments_validate.vue?vue&type=script&lang=js&"
import style0 from "./DataListLiftingEquipments_validate.vue?vue&type=style&index=0&id=87615ba2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87615ba2",
  null
  
)

export default component.exports